import PropTypes from 'prop-types';
import React from 'react';
import PageBlock from 'components/PageBlock';
import { Box, Heading, Text } from 'roo-ui/components';

const Header = ({ title, description, ...rest }) => (
  <PageBlock bg="white" px={[4, 6, 0]} {...rest} data-print-style="page-block">
    <Heading.h1 fontWeight="normal" data-testid="title">
      {title}
    </Heading.h1>
    <Box width={[1, 2 / 3]}>
      <Text fontSize="md" data-testid="description">
        {description}
      </Text>
    </Box>
  </PageBlock>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Header;
